import { inject } from '@angular/core';
import { CanActivateFn, CanMatchFn, Router } from '@angular/router';

// Rental accounts: Overview (the P&L page) is /overview and Properties (the
// property dashboard) is /properties. Every other account has no Properties
// tab: its Overview tab is the property dashboard, at /overview.
// The pros page is Contacts (/contacts) for rental accounts and Pros (/my-pros)
// for the rest; www.tidy.com/pros is the marketing site's page for pros.
const isRentalClient = (): boolean => localStorage.getItem('isRentalClient') === 'true';

// Where this account's property dashboard (DashboardPage) lives.
export const propertyDashboardPath = (): '/properties' | '/overview' => isRentalClient() ? '/properties' : '/overview';

export const rentalAccountMatch: CanMatchFn = () => isRentalClient();

// Property links were /overview?propertyId=… before the rename; they still
// open that property on the Properties page.
export const propertyLinkRedirect: CanActivateFn = (route) => {
  if (!route.queryParamMap.has('propertyId')) {
    return true;
  }
  return inject(Router).createUrlTree(['/properties'], { queryParams: route.queryParams });
};

// Opens the page for the account type it belongs to, else sends the link to the
// other account type's address for the same page.
const redirectOtherAccounts = (forRental: boolean, otherPath: string): CanActivateFn => (route) => {
  if (isRentalClient() === forRental) {
    return true;
  }
  return inject(Router).createUrlTree([otherPath], { queryParams: route.queryParams });
};

export const nonRentalPropertiesRedirect = redirectOtherAccounts(true, '/overview');

export const nonRentalContactsRedirect = redirectOtherAccounts(true, '/my-pros');

export const rentalProsRedirect = redirectOtherAccounts(false, '/contacts');

// Where this account's pros page lives.
export const prosPagePath = (): '/contacts' | '/my-pros' => isRentalClient() ? '/contacts' : '/my-pros';
